import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ChangeButtonView;
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useRef } from 'react';
import { Button, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { REGION_TEXTS } from "./consts";
import { useClassOnScroll } from "../../../../hooks/useClassOnScroll";
import { Metric } from "../../../../metric";
import { EHeaderTheme } from "../../../../store/slices/layout";
import { useBreakpointContext } from "../../../../../../components/BreakpointProvider";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var ChangeButtonView = (_ChangeButtonView = {}, _defineProperty(_ChangeButtonView, EHeaderTheme.primary, 'secondary-invert'), _defineProperty(_ChangeButtonView, EHeaderTheme.secondary, 'secondary'), _defineProperty(_ChangeButtonView, EHeaderTheme.dark, 'tertiary'), _ChangeButtonView);
var CloseIcon = function CloseIcon(params) {
  return /*#__PURE__*/React.createElement(IconCloseRoundStroked, _extends({}, params, {
    color: "secondary-invert",
    size: 20
  }));
};
export var RegionConfirmationWrapper = function RegionConfirmationWrapper(_ref) {
  var showConfirmation = _ref.showConfirmation,
    onChangeRegionClick = _ref.onChangeRegionClick,
    onApproveRegionClick = _ref.onApproveRegionClick,
    onCloseButtonClick = _ref.onCloseButtonClick,
    headerTheme = _ref.headerTheme,
    children = _ref.children;
  var _useBreakpointContext = useBreakpointContext(),
    isDesktop = _useBreakpointContext.isDesktop;
  var wrapperRef = useRef(null);
  useClassOnScroll(wrapperRef, cn({
    'region-confirmation--hidden': showConfirmation
  }));
  return showConfirmation ? /*#__PURE__*/React.createElement("div", {
    className: cn('region-confirmation', "region-confirmation--".concat(headerTheme)),
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('region')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('region-location'),
    size: "xs"
  }, REGION_TEXTS.current), children), /*#__PURE__*/React.createElement("div", {
    className: cn('control-buttons')
  }, /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: REGION_TEXTS.approve,
    events: {
      headerMetric: ['handleChangeRegionClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('button'),
    onClick: onApproveRegionClick,
    size: "m"
  }, REGION_TEXTS.approve)), /*#__PURE__*/React.createElement(Metric, {
    asChild: true,
    data: REGION_TEXTS.change,
    events: {
      headerMetric: ['handleChangeRegionClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(Button, {
    className: cn('button'),
    onClick: onChangeRegionClick,
    size: "m",
    view: ChangeButtonView[headerTheme]
  }, REGION_TEXTS.change))), !isDesktop && /*#__PURE__*/React.createElement(Button, {
    className: cn('close-button'),
    iconLeft: CloseIcon,
    mode: "inline",
    onClick: onCloseButtonClick
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};